import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';


const SalonThemeMobilePreviewSummary = ({ children, onOpenPreview }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        data-testid="salon-theme-mobile-preview-summary"
        style={{ height: '180px', overflow: 'hidden' }}
        sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
      >
        <Box
          data-testid="salon-theme-mobile-preview-content"
          aria-hidden="true"
          inert=""
          sx={{ height: '100%', pointerEvents: 'none' }}
        >
          {children}
        </Box>
      </Box>
      <Button
        type="button"
        onClick={onOpenPreview}
        sx={{ mt: 1, minHeight: 44 }}
      >
        {t('salon_theme.mobile.open_preview')}
      </Button>
    </Box>
  );
};

export default SalonThemeMobilePreviewSummary;
